import { Box, Typography } from '@mui/material';

interface RankBadgeProps {
  rank: number | null;
  size?: number;
  /** Velky rezim — inverzni barvy, pouzit v podium kartach. */
  inverse?: boolean;
}

/** Barevny gradient medaile (1-3), primary pro ostatni pozice, sedy pro null/NP. */
const gradientFor = (rank: number | null): string => {
  if (rank === 1) return 'linear-gradient(135deg, #FFD700 0%, #FFA000 100%)';
  if (rank === 2) return 'linear-gradient(135deg, #E0E0E0 0%, #9E9E9E 100%)';
  if (rank === 3) return 'linear-gradient(135deg, #D4A373 0%, #8B5A2B 100%)';
  return 'linear-gradient(135deg, #EEEEEE 0%, #BDBDBD 100%)';
};

const textColorFor = (rank: number | null): string => {
  if (rank === 3) return '#FFFFFF';
  if (rank == null) return '#616161';
  return '#1a1a1a';
};

/**
 * Kruhovy badge s poradim, barevne odliseny pro 1.-3. misto.
 * Nahrazuje EmojiEventsIcon trophy (= emoji), ktery nechceme pouzivat.
 */
export const RankBadge = ({ rank, size = 32, inverse = false }: RankBadgeProps) => {
  const bg = inverse ? '#FFFFFF' : gradientFor(rank);
  const color = inverse ? (rank != null && rank <= 3 ? '#1a1a1a' : '#616161') : textColorFor(rank);
  const border = inverse ? `2px solid ${rank === 1 ? '#FFA000' : rank === 2 ? '#9E9E9E' : rank === 3 ? '#8B5A2B' : 'transparent'}` : 'none';
  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '50%',
        background: bg,
        color,
        border,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size * 0.46,
        lineHeight: 1,
        boxShadow: rank != null && rank <= 3 ? '0 2px 6px rgba(0,0,0,0.15)' : 'none',
      }}
    >
      <Typography component="span" sx={{ fontWeight: 700, fontSize: 'inherit', color: 'inherit', lineHeight: 1 }}>
        {rank ?? '–'}
      </Typography>
    </Box>
  );
};
